import {useDispatch, useSelector} from "react-redux";
import React, {useState} from "react";
import {updatePmsSearchDetails} from "../../redux/actions/pmsSearch";
import {Button, Textarea} from "@headlessui/react";

export const SymptomsForm = ({onNext}) => {
  const dispatch = useDispatch();
  const pmsSearch = useSelector((state) => state.pmsSearch);

  const [error, setError] = useState(false);
  const [symptoms, setSymptoms] = useState(pmsSearch.symptoms ?? '');

  const tryNext = () => {
    if(!symptoms || symptoms.trim() === '') {
      setError(true);
      return;
    }

    completeStep();

    if (onNext) {
      onNext();
    }
  }

  const completeStep = () => {
    dispatch(updatePmsSearchDetails({symptoms}));
  }

  return (
    <div className='w-full flex flex-col px-2 mt-6 gap-1'>
      <span className='text-brand-alt text-sm'>
        Please describe the main issue you are you are seeking help for, along with any background details you feel are relevant.
      </span>
      <Textarea
        onChange={e => setSymptoms(e.target.value)}
        name='symptoms'
        type='text'
        className={`w-full min-h-[500px] bg-white appearance-none border border-gray-300 placeholder:text-gray-300 p-2 rounded-lg ${error && 'border-red-500 bg-red-50 placeholder:text-grey-500'} transition`}
        placeholder='Enter what worries you or other symptoms you may feel'
        value={symptoms}>
      </Textarea>
      {error && (
        <span className='text-red-500 text-xs'>Please provide some information about what is worrying you</span>
      )}
      <div className='py-4 w-full flex justify-end'>
        <Button onClick={tryNext}
                className='bg-brand text-white font-bold px-4 py-2 rounded-full hover:bg-white hover:text-brand transition'>
          Next step
        </Button>
      </div>
    </div>
  )
}
